export default ({ BREAKPOINTS }) => ({
  row: {
    padding: '20px 0',
    borderBottom: '1px solid #eee'
  },
  holder: {
    display: 'flex',
    flexDirection: 'row',
    margin: '0 -10px',
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      margin: '0',
      flexDirection: 'column'
    }
  }
})
